import React from 'react';
import BaseModal from 'components/molecules/BaseModal';
import { ModalIDs } from 'redux/reducers/gl_modal_reducer/types';
import { Box, List } from '@material-ui/core';
import { ListItem } from '@material-ui/core';
import TranslatedText from 'components/atoms/TranslatedText';
import { AppCheckbox } from 'components/atoms/StyledFormControls';
import AppButton from 'components/atoms/Button';
import { useDispatch } from 'react-redux';
import ModalActions from 'redux/reducers/gl_modal_reducer/actions';
import _ from 'lodash';

interface ISelectionsListModalProps {}

export interface IModalParams {
  options: Array<any>;
  idName: string;
  keyName: string;
  defaultOptionsMap: {
    [key: string | number]: string | number;
  };
  onSave: (newSelections: Array<any>) => {};
}

type SelectionsType = { [key: string | number]: string | number };

interface ModalProps extends IModalParams {
  selections: {
    current: SelectionsType;
  };
}

const SelectionsListModal = ({}: ISelectionsListModalProps) => {
  const selections = React.useRef<SelectionsType>({});

  return (
    <BaseModal
      modalID={ModalIDs.MODAL_OPTIONS}
      showExitIcon={true}
      contentProps={{ style: { padding: 0, margin: 0 } }}
      modalProps={{ fullWidth: true }}
      renderHeader={(params: IModalParams) => (
        <TranslatedText defaultText={`Options`} />
      )}
      renderContent={(params: IModalParams) => (
        <Content {...params} selections={selections} />
      )}
      renderFooter={(params: IModalParams) => (
        <Footer {...params} selections={selections} />
      )}
    />
  );
};

const Footer = (props: ModalProps) => {
  const dispatch = useDispatch();

  return (
    <React.Fragment>
      <AppButton
        text={<TranslatedText defaultText="Save" />}
        onClick={() => {
          props.onSave(Object.keys(props.selections.current));
          dispatch(
            ModalActions.closeModalAction({ modalID: ModalIDs.MODAL_OPTIONS })
          );
        }}
      />
    </React.Fragment>
  );
};

const Content = (props: ModalProps) => {
  return (
    <List>
      {props.options.map((el, index) => {
        return (
          <ListElement
            isSelected={el[props.idName] in props.defaultOptionsMap}
            key={el[props.idName]}
            label={el[props.keyName]}
            selections={props.selections}
            elemId={el[props.idName]}
          />
        );
      })}
    </List>
  );
};

interface IListElementProps {
  label: string;
  isSelected: boolean;
  selections: {
    current: SelectionsType;
  };
  elemId: string | number;
}

const ListElement = (props: IListElementProps) => {
  const [selected, setSelected] = React.useState<boolean>(props.isSelected);

  React.useEffect(() => {
    if (selected) {
      props.selections.current[props.elemId] = props.elemId;
      // _.set(props.selections, 'current', props.elemId);
    } else {
      delete props.selections.current?.[props.elemId];
    }
  }, [selected]);

  return (
    <span onClick={() => setSelected(!selected)}>
      <ListItem button>
        <Box display="flex" alignItems="center">
          <AppCheckbox
            disableRipple
            checked={selected}
            style={{ marginRight: '0.5rem' }}
          />
          {props.label}
        </Box>
      </ListItem>
    </span>
  );
};

export default React.memo(SelectionsListModal);
